import { DataBean } from "../DataBean";

export class OutputAuthorizationItem extends DataBean {


  public async getOutputAuthorizationItemCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "java.util.List_getOutputAuthorizationItemCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getOutputAuthorizationItemRender(page: number, rows: number, properties: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.advantage.shared.Report_getOutputAuthorizationItemRender_Number_Number_java.util.Map",
      [page, rows, properties]
    );
  }

  public async deleteOutputAuthorizationItem(idoutputauthorizationitem: number): Promise<any> {
    return this.getCustomService("ProcessContractERP", "boolean_deleteOutputAuthorizationItem_Number", [idoutputauthorizationitem]);
  }

  public async updateOutputAuthorizationItem(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessContractERP",
      "com.orange.finance.processcontract.bean.OutputAuthorizationItem_updateOutputAuthorizationItem_com.orange.finance.processcontract.bean.OutputAuthorizationItem",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.orange.finance.processcontract.bean.OutputAuthorizationItem",
        },
      ]
    );
  }
}
